"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var StepCounter = function (props) {
    var total = props.total, step = props.step;
    return (react_1["default"].createElement(core_1.Grid, { container: true, justify: "space-between", style: { margin: '55px 0 25px 0' } }, Array.from({ length: total }).map(function (_, index) {
        return (react_1["default"].createElement("div", { key: index, style: {
                display: 'inline',
                backgroundColor: index === step || (props.colorAll && index < step)
                    ? 'var(--primary)'
                    : 'var(--gray)',
                height: '4px',
                width: "calc((100% - (" + total + " - 1) * 5px) / " + total + ")"
            } }));
    })));
};
exports["default"] = StepCounter;
